import React from 'react';
import classNames from 'classnames';

export interface SpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | number;
  color?: 'primary' | 'white' | 'current';
}

const sizeMap = {
  sm: 16,
  md: 20,
  lg: 24,
};

const Spinner: React.FC<SpinnerProps> = ({
  className,
  size = 'md',
  color = 'primary',
}) => {
  const spinnerSize = typeof size === 'number' ? size : sizeMap[size];

  const colorClass = {
    primary: 'text-primary',
    white: 'text-white',
    current: 'text-current',
  }[color];

  return (
    <svg
      className={classNames('animate-spin', colorClass, className)}
      style={{ width: spinnerSize, height: spinnerSize }}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};

export default Spinner;
